import { render } from "./ProtostarsEY.vue?vue&type=template&id=7186abf2"
import script from "./ProtostarsEY.vue?vue&type=script&lang=js"
export * from "./ProtostarsEY.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__